import React from 'react';

import * as T from './types';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
export const UserPicture: React.FC<T.IProps> = ({
    imageURL,
    username,
    firstname,
    lastname,
    ...props }) => {
    const avatarFallback = firstname.charAt(0).toUpperCase() + lastname.charAt(0).toUpperCase();
    return (
        <Avatar className="h-10 w-10 text-neutral-700 dark:text-neutral-300 border dark:border-slate-700/70" {...props}>
            {!imageURL?.startsWith('https://avatars.planningcenteronline.com/uploads/initials') ?
                <AvatarImage src={imageURL} alt={username} />
                : <></>
            }

            <AvatarFallback>{avatarFallback}</AvatarFallback>
        </Avatar>
    )
}